import React from 'react';
import { Link } from 'react-router-dom';
import { MapPinIcon, CheckCircleIcon, StarIcon } from 'lucide-react';
import { Developer } from '../../utils/types';
import { Card } from '../ui/Card';
import { Button } from '../ui/Button';
interface TalentCapsuleCardProps {
  developer: Developer;
  featured?: boolean;
}
export const TalentCapsuleCard = ({
  developer,
  featured = false
}: TalentCapsuleCardProps) => {
  return <Link to={`/developer/${developer.id}`} className="block h-full" data-id="element-32">
      <div className={`h-full bg-[#1a1d24] rounded-2xl border border-gray-800 hover:border-gray-700 transition-all duration-300 overflow-hidden group hover:shadow-xl hover:shadow-black/20 ${featured ? 'md:col-span-2 flex flex-col md:flex-row' : 'flex flex-col'}`} data-id="element-33">
        {/* Header / Cover */}
        <div className={`relative bg-gradient-to-r from-gray-900 to-gray-800 ${featured ? 'md:w-1/3 h-48 md:h-auto' : 'h-24'}`} data-id="element-34">
          {/* Status Badge */}
          <div className="absolute top-4 right-4" data-id="element-35">
            <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${developer.status === 'available' ? 'bg-green-500/10 text-green-400 border border-green-500/20' : 'bg-gray-700 text-gray-300 border border-gray-600'}`} data-id="element-36">
              <span className={`w-1.5 h-1.5 rounded-full mr-1.5 ${developer.status === 'available' ? 'bg-green-400' : 'bg-gray-400'}`} data-id="element-37"></span>
              {developer.status === 'available' ? 'Available' : 'Unavailable'}
            </span>
          </div>

          {/* Avatar */}
          <div className={`absolute ${featured ? 'bottom-0 left-1/2 transform -translate-x-1/2 translate-y-1/2 md:top-1/2 md:left-1/2 md:-translate-y-1/2' : 'bottom-0 left-6 transform translate-y-1/2'}`} data-id="element-38">
            <div className="relative" data-id="element-39">
              <img src={developer.avatar} alt={developer.name} className={`rounded-full border-4 border-[#1a1d24] object-cover ${featured ? 'w-32 h-32' : 'w-20 h-20'}`} data-id="element-40" />
              {developer.verified && <div className="absolute bottom-1 right-1 bg-white rounded-full p-1 shadow-md" data-id="element-41">
                  <CheckCircleIcon className="w-4 h-4 text-[#d73b3e]" data-id="element-42" />
                </div>}
            </div>
          </div>
        </div>

        {/* Content */}
        <div className={`flex-1 p-6 ${featured ? 'md:p-8 md:pl-24 pt-16' : 'pt-12'}`} data-id="element-43">
          <div className="flex justify-between items-start mb-2" data-id="element-44">
            <div data-id="element-45">
              <h3 className="font-bold text-lg text-white group-hover:text-[#d73b3e] transition-colors" data-id="element-46">
                {developer.name}
              </h3>
              <p className="text-sm text-gray-400" data-id="element-47">{developer.title}</p>
            </div>
            <div className="text-right" data-id="element-48">
              <div className="font-bold text-white" data-id="element-49">
                €{developer.hourlyRate}/hr
              </div>
              <div className="flex items-center text-xs text-gray-500 justify-end mt-1" data-id="element-50">
                <MapPinIcon className="w-3 h-3 mr-1" data-id="element-51" />
                {developer.country}
              </div>
            </div>
          </div>

          {/* Skills */}
          <div className="mt-4 flex flex-wrap gap-2" data-id="element-52">
            {developer.skills.slice(0, featured ? 6 : 3).map(skill => <span key={skill.name} className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-800 text-gray-300 border border-gray-700" data-id="element-53">
                {skill.name}
              </span>)}
            {developer.skills.length > (featured ? 6 : 3) && <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-800 text-gray-400 border border-gray-700" data-id="element-54">
                +{developer.skills.length - (featured ? 6 : 3)}
              </span>}
          </div>

          {/* Bio (Featured only) */}
          {featured && <p className="mt-4 text-gray-400 text-sm line-clamp-2" data-id="element-55">
              {developer.bio}
            </p>}
        </div>
      </div>
    </Link>;
};